import { useQuery } from "@tanstack/react-query"

import { useApiContext } from "@/hooks/api/use-api-context"
import { useBookId } from "@/hooks/use-book-id"

import { fetchElevateAccounts, fetchElevateIntegrations } from "./api"

export function useElevateAccounts() {
  const getContext = useApiContext()
  const bookId = useBookId()
  return useQuery({
    queryKey: ["elevate-accounts", bookId],
    queryFn: async () => fetchElevateAccounts(await getContext()),
  })
}

export function useElevateIntegrations() {
  const getContext = useApiContext()
  const bookId = useBookId()
  return useQuery({
    queryKey: ["elevate-integrations", bookId],
    queryFn: async () => fetchElevateIntegrations(await getContext()),
    refetchInterval: 60000,
  })
}
